import {UHFInteractionService} from '../services/uhf-interaction.service';
import {AppAction, AppActionState, IAppState} from '../../store/interfaces/IAppState';
import {CommonActionsDelegate} from './common-actions.delegate';
import {store} from '../../store/store';
import {NgRedux} from '@angular-redux/store';
import {Actions} from '../../store/actions';
import {LogService} from '../services/logging.service';
import {ReservationService} from '../services/reservation.service';
import {HotelService} from '../services/hotel.service';
import {MemberService} from '../services/member.service';
import {Inject, Injectable} from '@angular/core';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {APP_CONFIG} from '../config/app.config';
import {UserStatusType} from '../model/user/user-status-type.model';
import {User} from '../model/user/user.model';
import {TranslationService} from '../services/translations.service';

@Injectable()
export class AppActionsDelegate extends CommonActionsDelegate {
  constructor(_ngRedux: NgRedux<IAppState>,
              _actions: Actions,
              _logService: LogService,
              _reservationService: ReservationService,
              _hotelService: HotelService,
              _memberService: MemberService,
              @Inject(APP_CONFIG) private _appConfig: IAppConfig,
              private _translationService: TranslationService,
              private _uhfInteractionService: UHFInteractionService) {
    super(_ngRedux, _actions, _logService, _reservationService, _hotelService, _memberService);
  }
  bootstrap() {
    this._actions.dispatchAppConfig(AppAction.APPCONFIG_BOOTSTRAP, this._appConfig);
    this._logService.start(this._appConfig);
    this._translationService.loadTranslations();

    this._uhfInteractionService.bootstrap(
      (loginStatus: UserStatusType) => {
        if (this._ngRedux.getState().member
          && this._ngRedux.getState().member.loginStatus !== loginStatus) {
          if (UserStatusType.isExplicit(loginStatus)) {
            this.fetchMember(AppAction.CHANGE_MEMBER_STATUS, new User(loginStatus));
          } else {
            const updatedMember = Object.assign(new User(loginStatus), this._ngRedux.getState().member, {loginStatus: loginStatus});
            this._actions.dispatchMemberAction(AppAction.CHANGE_MEMBER_STATUS, AppActionState.SUCCESS, updatedMember);
          }
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/app-actions.delegate.ts